import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Popover} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import SignalField from '../Signal'
import TradeSelect from '../TradeSelect'
import TickersInput from 'Components/Builder/TickersInput'
import StockFilterSelect from '../StockFilterSelect'

import style from './fields.sass'

@inject('store') @observer
class Main extends Component {
  handleChange = (name, value) => {
    this.props.store.algo.single.change(name, value)
  }
  changeTickers = (value) => {
    this.props.store.algo.single.change('tickers', value)
  }
  removeError = (name) => {
    this.props.store.algo.single.removeError(name)
  }
  render() {
    const {data, errors} = this.props.store.algo.single
    const hasCoin = this.props.hasCoin
    return(
      <div styleName='wrapper'>
        <div styleName='signal-container'>
          <label>Signal:*</label>
          <Popover
            content={popovers.signal}
            placement='right'
            styleName='popover'
          >
            <span>
              <FontAwesomeIcon icon='question-circle'/> Samples
            </span>
          </Popover>
          <SignalField
            name='signal'
            has_coin={hasCoin}
          />
          <p styleName='error' dangerouslySetInnerHTML={{__html:errors.signal}}/>
        </div>
        <div>
          <div styleName='trade'>
            <label>Trade:*</label>
            <TradeSelect
              name='trade_type'
              type='trade'
              value={data.trade_type}
              tradeValue={data.trade_value}
              hasCoin={hasCoin}
              changeHandler={this.handleChange}
              placeholder='Select trade type'
            />
          </div>
          <div styleName='tickers-row'>
            <div>
              <label>Tickers:</label>
              <Popover
                content={popovers.tickers}
                placement='right'
                styleName='popover'
              >
                <span>
                  <FontAwesomeIcon icon='question-circle'/>
                </span>
              </Popover>
              <TickersInput
                name='tickers'
                changeHandler={this.changeTickers}
                tickers={data.tickers}
                errors={errors}
                removeError={this.removeError}
                wideDropdown={true}
              />
            </div>
            <div>
              <label>Ticker lists:</label>
              <Popover
                content={popovers.stock_filter}
                placement='right'
                styleName='popover'
              >
                <span>
                  <FontAwesomeIcon icon='question-circle'/>
                </span>
              </Popover>
              <StockFilterSelect
                changeHandler={this.handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const popovers = {
  signal: (
    <div>
      <p><b>Type your buy signal here.</b></p>
      <div><i>Examples:</i></div>
      <ul>
        <li>20 day moving average crosses above 100 day moving average AND RSI is less than 75</li>
        <li>AAPL high is 3% above yesterday close and SPX open is below yesterday close</li>
        <li>Close crosses above upper bollinger band and market sentiment is above 0</li>
        <li>Current month pct devices in store is 20% higher than last month pct devices in store</li>
      </ul>
      <p className={style.highlighted}><b>Type @ to see a list of available indicators.</b></p>
    </div>
  ),
  tickers: (
    <div>
      <div><i>Examples:</i></div>
      <ul>
        <li>AAPL</li>
        <li>AAPL, FB</li>
      </ul>
    </div>
  ),
  stock_filter: (
    <div>
      You can create new lists on the <Link to='/stock-filters/builder'>Screener</Link> page
    </div>
  )
}

export default Main
